export default __webpack_public_path__ + "static/media/(6).051a96c3.jpeg";